/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Input,
  Label,
  InputGroupAddon,
  InputGroupText,
  InputGroup
} from "reactstrap";

const TSText = props => {
  const checkReadOnly = p => {
    if (p.readOnly !== undefined) {
      return p.readOnly === true || p.readOnly === "readonly" || p.readOnly === "true";
    }
    if (p.readonly !== undefined) {
      return p.readonly === true || p.readonly === "readonly" || p.readonly === "true";
    }
    if (p.isReadOnly !== undefined) {
      return p.isReadOnly === true || p.isReadOnly === "true";
    }
    return false;
  };

  const checkDisabled = p => {
    if (p.disabled !== undefined) {
      return p.disabled === true || p.disabled === "disabled" || p.disabled === "true";
    }
    if (p.isDisabled !== undefined) {
      return p.isDisabled === true || p.isDisabled === "true";
    }
    return false;
  };

  const [value, setValue] = useState(props.value !== null && props.value !== undefined ? props.value : "");
  const [label, setLabel] = useState(props.label !== null && props.label !== undefined ? props.label : "");
  const [name, setName] = useState(props.name !== null && props.name !== undefined ? props.name : "");
  const [type, setType] = useState(props.type !== null && props.type !== undefined ? props.type : "text");
  const [placeholder, setPlaceholder] = useState(
    props.placeholder !== null && props.placeholder !== undefined ? props.placeholder : ""
  );
  const [icon, setIcon] = useState(props.icon !== null && props.icon !== undefined ? props.icon : "");
  const [isRequire, setIsRequire] = useState(props.isRequire);
  const [maxLength, setMaxLength] = useState(
    props.maxLength !== "undefined" ? props.maxLength : null
  );
  const [disabled, setDisabled] = useState(() => checkDisabled(props));
  const [readOnly, setReadOnly] = useState(() => checkReadOnly(props));

  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setValue(props.value);
    }
    setDisabled(checkDisabled(props));
    setReadOnly(checkReadOnly(props));
    if (props.label !== undefined) setLabel(props.label !== null ? props.label : "");
    if (props.name !== undefined) setName(props.name !== null ? props.name : "");
    if (props.placeholder !== undefined) setPlaceholder(props.placeholder !== null ? props.placeholder : "");
    if (props.icon !== undefined) setIcon(props.icon !== null ? props.icon : "");
    if (props.isRequire !== undefined) setIsRequire(props.isRequire);
    if (props.maxLength !== undefined) setMaxLength(props.maxLength !== "undefined" ? props.maxLength : null);
    if (props.type !== undefined) setType(props.type !== null ? props.type : "text");
  }, [
    props.value,
    props.disabled,
    props.isDisabled,
    props.readOnly,
    props.readonly,
    props.isReadOnly,
    props.label,
    props.name,
    props.placeholder,
    props.icon,
    props.isRequire,
    props.maxLength,
    props.type
  ]);

  function handleChange(e) {
    if (readOnly || disabled) return;
    if (props.onChange) {
      if (props.type === "tel") {
        const re = /^[0-9\b]+$/;
        if (e.target.value === "" || re.test(e.target.value)) {
          props.onChange(e);
          setValue(e.target.value);
        }
      } else {
        props.onChange(e);
        setValue(e.target.value);
      }
    } else {
      setValue(e.target.value);
    }
  }

  const displayValue = props.value !== undefined && props.value !== null ? props.value : value;

  return (
    <div>
      <Label for="">{label}</Label>
      <InputGroup style={{ border: isRequire ? "solid red" : "" }}>
        <InputGroupAddon addonType="prepend">
          <InputGroupText style={{ borderRadius: "0", padding: "10px 10px" }}>
            <i className={icon !== null && icon !== "" ? icon : ""}></i>
          </InputGroupText>
        </InputGroupAddon>
        <Input
          style={{
            borderRadius: "0",
            backgroundColor: readOnly ? "#e9ecef" : undefined,
            cursor: readOnly ? "default" : undefined,
            ...(props.style || {})
          }}
          placeholder={placeholder}
          name={name}
          type={type}
          maxLength={maxLength}
          value={displayValue}
          disabled={disabled}
          readOnly={readOnly}
          onChange={handleChange}
        />
      </InputGroup>
    </div>
  );
};

export default TSText;
